module.exports = __webpack_public_path__ + "static/media/happy_hour.3485791f.jpeg";